import { Component, OnInit, Input } from '@angular/core';
import { PersonEvaluationResponsesDetail } from 'src/app/shared/models/evaluation/personEvaluationResponsesDetail';

@Component({
  selector: 'app-person-evaluation-details',
  templateUrl: './person-evaluation-details.component.html',
  styleUrls: ['./person-evaluation-details.component.scss'],
  standalone: false
})
export class PersonEvaluationDetailsComponent implements OnInit {
  @Input() data: PersonEvaluationResponsesDetail;
  constructor() {}

  ngOnInit(): void {}
}
